import {blue} from "./blue";
import {brand} from "./brand";

export const daily5 = {
    default: brand.default,
    subtle: brand.subtle,
    strong: blue[90],
};
